import useSecurityData from '@usas/ui-web/state/security/UseSecurityData';

const useNotLoggedInMessage = () => {
  const { login } = useSecurityData();

  const onLoginClicked = (e) => {
    e?.preventDefault();

    login();
  };

  const onCreateAccountClicked = (e) => {
    e?.preventDefault();

    window.location.href = `${import.meta.env.VITE_LOGIN_URL}?returnPath=${encodeURIComponent(window.location.pathname)}&returnProject=${import.meta.env.VITE_PROJECT_NAME}&returnLabel=${'OMR'}`;
  };

  return {
    onLoginClicked,
    onCreateAccountClicked
  };
};

export default useNotLoggedInMessage;